'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ImageAsset = require('./ImageAsset');

var _ImageAsset2 = _interopRequireDefault(_ImageAsset);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ImageAsset2.default;
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-image/lib/cjs/ImageAsset/index.js
 ** module id = 300
 ** module chunks = 1
 **/